/** COPYRIGHT NOTICE
 *
 *  Copyright (C) Vokke.
 *  All Rights Reserved
 *
 *  This file was developed by Vokke and is only to be used by a person or legal
 *  entity when expressly granted a license to do so through written means.
 *
 *  Unauthorized usage, sharing or copying of this file, via any medium is
 *  strictly prohibited. Proprietary and confidential. This license header
 *  is not to be removed.
 *
 */

import { Application, KernelRoute, KernelRouteEndpoint } from "./abstraction/abstraction";
import Router from "./core/router";

export const App = new Application();

/** Expose the common modules **/
export {
    KernelRoute,
    KernelRouteEndpoint
} from "./abstraction/abstraction";



// WEBPACK FOOTER //
// ./public/kernel/kernel.js